import { useState } from "react";
import PrimaryButton from "../../common/components/PrimaryButton";
import InvitationForm from "./InvitationForm";
import EditPagePermissions from "./EditPagePermissions";
import { useApp } from "../../common/contexts/AppContext";

function refactorUsers(usersData) {
  const users = [];

  const { organizationOwner, invitations, organizationMembers } = usersData;

  users.push({
    email: organizationOwner?.owner?.email,
    isProductAdmin: true, // owner is product admin
  });

  if (invitations?.length) {
    invitations.forEach((invitation) => {
      const { email, _id } = invitation;

      users.push({ invitationId: _id, email, isInvited: true });
    });
  }

  if (organizationMembers?.length) {
    organizationMembers.forEach((member) => {
      users.push({
        userId: member?.user?._id,
        email: member?.user?.email,
        isMember: true,
      });
    });
  }

  return users;
}

const buttonCls = "back_link";

function ListUsers({
  openInviteForm,
  setOpenInviteForm,
  usersData = {},
  sendInvitationProps,
  reSendInvitationProps,
  editMemberPermissionsProps,
}) {
  const [resendId, setResendId] = useState("");
  const users = refactorUsers(usersData);

  const { isOwner } = useApp();

  const { reSendInvitationMutate, isReSendingInvitation } =
    reSendInvitationProps;

  const { editMemberPermissions, setEditMemberPermissions } =
    editMemberPermissionsProps;

  return (
    <div className="md:w-3/5">
      <div className="mb-6 flex items-center justify-between">
        <div className="font-bold text-gray-700 my-2 text-2xl font-bold">
          Users
        </div>

        <PrimaryButton
          btnCls="!w-fit h-10"
          buttonProps={{
            onClick: () => setOpenInviteForm(true),
          }}
        >
          + Invite
        </PrimaryButton>
      </div>

      {users?.map((user, i) => {
        const { email, isProductAdmin, isMember, invitationId, userId } = user;

        const isResending = resendId === invitationId && isReSendingInvitation;

        return (
          <div
            className="flex justify-between items-center py-4 border-b border-gray-300"
            key={i}
          >
            <div>
              {email}
              {isProductAdmin ? (
                <span className="ml-2 px-2 py-1 bg-gray-200 text-gray-800 text-xs rounded-md uppercase font-bold">
                  product admin
                </span>
              ) : null}
            </div>

            {isOwner ? (
              <>
                {isProductAdmin ? null : (
                  <>
                    {isMember ? (
                      <button
                        className={buttonCls}
                        onClick={() => {
                          setEditMemberPermissions({
                            userId,
                            email,
                          });
                        }}
                      >
                        Edit page configuration
                      </button>
                    ) : (
                      <button
                        className={buttonCls}
                        onClick={() => {
                          reSendInvitationMutate({ invitationId });
                          setResendId(invitationId);
                        }}
                        disabled={isResending}
                      >
                        {isResending ? "Resending invite" : "Resend invite"}
                      </button>
                    )}
                  </>
                )}
              </>
            ) : null}
          </div>
        );
      })}

      {openInviteForm ? (
        <InvitationForm
          open={openInviteForm}
          setOpen={setOpenInviteForm}
          sendInvitationProps={sendInvitationProps}
        />
      ) : null}

      {editMemberPermissions ? (
        <EditPagePermissions
          open={editMemberPermissions}
          setOpen={setEditMemberPermissions}
          memberData={editMemberPermissions}
        />
      ) : null}
    </div>
  );
}

export default ListUsers;
